if (!customElements.get("back-to-top")) {
  customElements.define(
    "back-to-top",
    class BackToTop extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Add an event listener to the existing button
        const backToTopButton = this.querySelector("button");
        if (backToTopButton) {
          backToTopButton.addEventListener("click", () => this.backToTop());
        }
      }

      // Function to clone and add a file field input element with an appended index
      backToTop() {
        // Scroll to the top of the page with smooth behavior
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    }
  );
}
